module.exports = __webpack_public_path__ + "img/all_mouth.08ae3351.jpg";